"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCheapestPackage = void 0;
const getPackageTotalCostForDate_1 = require("./getPackageTotalCostForDate");
const getCheapestPackage = (date, pkgs) => {
    if (pkgs.length === 0)
        return 0;
    const cheapest_package = pkgs.reduce((prev, curr) => {
        return (0, getPackageTotalCostForDate_1.getPackageTotalCostForDate)(date, prev) <
            (0, getPackageTotalCostForDate_1.getPackageTotalCostForDate)(date, curr)
            ? prev
            : curr;
    });
    return cheapest_package;
};
exports.getCheapestPackage = getCheapestPackage;
